import styled from 'styled-components';
import { grid, GridProps } from 'styled-system';

export const Wrapper = styled.div<GridProps>`
  display: flex;
  flex-direction: column;
  ${grid};
`;

export const Header = styled.div`
  display: flex;
  column-gap: 1ch;
  align-items: center;
`;
